import {Component, EventEmitter, ViewChild, Output, OnInit, ElementRef} from '@angular/core';
import {ApiService} from '@services/api.service';
import {catchError, map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {CommonModule, DatePipe, NgOptimizedImage} from '@angular/common';
import {TruncatePipe} from '../../truncate.pipe';
import {HttpClientModule} from '@angular/common/http';
import {PaginationComponent} from '@components/pagination/pagination.component';
import {SearchPanelComponent} from '@components/search-panel/search-panel.component';
import { Router } from '@angular/router';
import {
  DocumentType,
  DocumentTypeListResponse,
  IdLabel,
  ProcedureListItem,
  ProcedureListResponse, TagsResponse,
  TypeResponse
} from '../../models/output.model';
import {SearchConfigRequest} from '../../models/search-config.model';
import {Procedures} from '../../models/input.model';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {UtilsService} from '@services/utils.service';

@Component({
  selector: 'app-procedures',
  imports: [CommonModule, DatePipe, TruncatePipe, HttpClientModule, PaginationComponent, SearchPanelComponent, NgOptimizedImage, FormsModule, ReactiveFormsModule],
  templateUrl: './procedures.component.html',
  styleUrl: './procedures.component.css'
})
export class ProceduresComponent implements OnInit {


  @Output() navigate = new EventEmitter<string>();

  procedures$!: Observable<ProcedureListItem[]>
  totalRows: number = 0;
  pagingParams!: {offset: number, limit: number};

  searchPanelConfig: SearchConfigRequest[] = [
    {key: 'name', label: 'Oggetto', type: 'text'},
    {key: 'code', label: 'Numero registrazione', type: 'text'},
    {key: 'tags', label: 'Linea', type: 'select', options: []},
    {key: 'document_type_id', label: 'Tipologia documentale', type: 'select', options: []},
    {key: 'date_from', label: 'Dal', type: 'date'},
    {key: 'date_to', label: 'Al', type: 'date'},
  ]

  currentSort: {
    field: string; order: 'asc' | 'desc' } = {
    field: 'id',
    order: 'desc',
  }

  currentFilters: Procedures | {} = {}

  constructor(
    private router: Router,
    private utilsSvc: UtilsService,
    private apiService: ApiService,
  ) {
  }

  ngOnInit(): void {
    this.fetchDocumentsTypes()
    this.fetchDocumentsTags()
    this.pagingParams = this.utilsSvc.pagination
    this.currentSort = {... this.currentSort, ...this.pagingParams};
    this.fetchProcedures(this.currentSort)
  }

  refresh(): void {
    this.pagingParams = {...this.utilsSvc.pagination, ...{offset:0}}
    this.currentFilters = {...this.currentFilters, ...this.currentSort , ...{offset:0} }
    this.fetchProcedures(this.currentFilters)
  }

  onRowClicked(id: number) {
    this.router.navigate(['/atti-amministrativi', id]);
  }

  fetchProcedures(params: Procedures | {}) {

    params = {
      ...params,
      order: this.currentSort.order,
      order_field: this.currentSort.field,
    }

    this.procedures$ = this.apiService.getProcedures(params  ).pipe(
      map((response: ProcedureListResponse) => {
        if (response.result.status != 'error') {
          this.totalRows = response.result.total_row
          return response.result.data
        } else {
          return []
        }
      }),
      catchError(error => {
        console.error("Errore nel recupero degli ordini di servizio", error);
        return of([])
      })
    )
  }


  goToPage(page: Procedures) {
    this.currentFilters = {...this.currentFilters, ...this.currentSort , ...page}
    this.onSearchParamChange(this.currentFilters as Procedures )
  }

  onSearchParamChange(params: Procedures): void  {
    if(params == null || Object.keys(params).length === 0) {
      this.currentFilters = { ...this.currentSort }
    } else {
      this.currentFilters = {...this.currentFilters, ...this.currentSort, ...params}
    }
    this.fetchProcedures(this.currentFilters);
  }

  setOrder(field: string) {
    if (this.currentSort.field === field) {
      this.currentSort.order = this.currentSort.order === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSort.field = field;
      this.currentSort.order = 'asc'
    }
    this.fetchProcedures(this.currentFilters)
  }

/*  fetchRequestTypes() {
    this.requestTypes$ = this.apiService.getAdminTypes().pipe(
      map((response: TypeResponse) => response.data.sort((a, b) => a.label.localeCompare(b.label))),
      catchError(error => {
        console.error("Errore nel recupero dei types", error);
        return of([])
      })
    )
  }*/
  fetchDocumentsTypes(): void {

    const typeConfig = this.searchPanelConfig.find((config: SearchConfigRequest) => config.key === 'document_type_id')
    if (typeConfig) {
      this.apiService.getAdminTypes().pipe(
        map((response: TypeResponse) => response.data.sort((a: IdLabel, b: IdLabel) => a.label.localeCompare(b.label))),
        catchError(error => {
          console.error("Errore nel recupero dei types", error);
          return of([])
        })
      ).subscribe({
        next: (types: DocumentType[]) => {
          typeConfig.options = types.map((item: IdLabel) => {
            return {
              label: item.label,
              value: item.id + ""
            };
          });
        },
        error: error => {
          console.error("Errore nel recupero dei types", error);
        }
      })
    }
  }

  fetchDocumentsTags(): void {
    const tagsConfig = this.searchPanelConfig.find((config: SearchConfigRequest) => config.key === 'tags')
    if (tagsConfig) {
      this.apiService.getAdminTags().pipe(
        map((response: TagsResponse) => response.data.sort((a: IdLabel, b: IdLabel) => a.label.localeCompare(b.label))),
        catchError(error => {
          console.error("Errore nel recupero dei types", error);
          return of([])
        })
      ).subscribe({
        next: (types: IdLabel[]) => {
          tagsConfig.options = types.map((item: IdLabel) => {
            return {
              label: item.label,
              value: item.label
            };
          });
        },
        error: error => {
          console.error("Errore nel recupero dei tags", error);
        }
      })
    }
  }

}
